<template>
  <div
    v-if="requiredRoles.length === 0 || hasAccess(requiredRoles)"
    :class="['tech_content_card', 'text-center', 'd-flex', 'flex-column', 'align-center', props.padded ? 'pa-6' : 'pa-0']">
    <span class="w-100 d-flex flex-column align-center">
      <!-- Title -->
      <h1 class="mt-0 mb-2 lang_translate" style="font-size: 19px">
        {{ title }}
      </h1>

      <!-- Description (only render if not empty) -->
      <p
        v-if="description.trim() !== ''"
        class="pt-0 pb-3 w-md-100 font-weight-light lang_translate"
        style="font-size: 15px; color: rgb(var(--v-theme-primary)); width: 300px">
        {{ description }}
      </p>

      <!-- Buttons -->
      <div v-if="showPrimary || showSecondary" class="d-flex flex-row justify-center ga-4">
        <Button
          v-if="showPrimary"
          class="w-auto lang_translate"
          :slim="true"
          version="primary"
          :label="primaryLabel"
          @click="onPrimaryClick" />
        <Button
          v-if="showSecondary"
          class="w-auto lang_translate"
          :slim="true"
          version="action"
          :label="secondaryLabel"
          @click="onSecondaryClick" />
      </div>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import { useUserDataStore, UserInfo } from '@/store/userDataStore';
import { useModalStore } from '@/store/modalStore';

import Button from '@/components/ComponentLibrary/Button.vue';

const router = useRouter();
const userDataStore = useUserDataStore();
const modalStore = useModalStore();

// Access checker
function hasAccess(roles: (keyof UserInfo['membership_tiers'])[]) {
  return userDataStore.hasAccess(roles);
}

// Props - all required
const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true }, // always required, but can be ""
  requiredRoles: {
    type: Array as PropType<(keyof UserInfo['membership_tiers'])[]>,
    required: true,
  },
  showPrimary: { type: Boolean, required: true },
  primaryLabel: { type: String, required: true },
  primaryRoute: { type: String, required: true },
  showSecondary: { type: Boolean, required: true },
  secondaryLabel: { type: String, required: true },
  secondaryRoute: { type: String, required: true },
  padded: { type: Boolean, required: true },
});

// Navigation helper
function navigate(route: string) {
  if (!route) return;
  if (route.startsWith('http')) {
    window.open(route, '_blank'); // external link
  } else {
    router.push(route); // internal route
  }
}

// Methods
function onPrimaryClick() {
  navigate(props.primaryRoute);
}

function onSecondaryClick() {
  navigate(props.secondaryRoute);
  modalStore.closeModal();
}
</script>
